import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Plyr from '@lwtears/lwt-common-frontend/lib/Player';
import { createEvent } from 'api';
import imageSrc from 'assets/images/kid-floating-icons.png';
import { fetchSupportResources } from 'state/modules/entity/custom/resource-favorites-mutations/thunks/resource-thunks';
import { ModalPadding } from 'styles/style-constants';
import { FONT_GSS_FUTURA } from 'themes/default';
import SquareButton from '../Buttons/SquareButton';
import WebLink from '../WebLink';
import { remCalc } from '../../../util/style-util';
import { translate } from '../../../translations/translator';

const translateModals = key => translate('modals', key);

type Props = {
  closeModal: () => void;
};

const Welcome = ({ closeModal }: Props) => {
  const [hittWelcomeVideo, setHittWelcomeVideo] = useState<any>(null);
  const [selectedResource, setSelectedResource] = useState<any>(null);
  const [playerVisible, setPlayerVisible] = useState<boolean>(false);

  const classes = useStyles()();

  useEffect(() => {
    fetchSupportResources().then(resources => setHittWelcomeVideo(resources.data[0]));
  }, []);

  const createTelemetryEvent = resource => {
    const event = {
      section: 'welcome',
      resourceId: resource.id,
      resourceType: resource.resourceType
    };

    createEvent('accessResource', event);
  };

  const handleWatchVideo = () => {
    const resource = hittWelcomeVideo as any;
    const liteResource = {
      id: resource?.id,
      title: resource?.title,
      resourceType: resource?.type?.type,
      mediaType: resource?.data?.mediaType,
      url: resource?.url,
      aspectRatio: resource?.data?.aspectRatio,
      heightAdjust: resource?.data?.heightAdjust,
      fileExtension: resource?.data?.fileExtension
    };

    setSelectedResource(liteResource);
    setPlayerVisible(true);
    createTelemetryEvent(liteResource);
  };

  return (
    <div>
      {!playerVisible ? (
        <div className={classes.welcomeModal}>
          <img className={classes.modalImage} src={imageSrc} alt="IDTT Logo with Buttons" />
          <h2 className={classes.modalHeading}>{translateModals('welcome')}</h2>
          <p className={classes.modalText}>{translateModals('welcomeToIDTT')}</p>
          <SquareButton
            //buttonStyles={[styles.modalButton]}
            style={{ fontWeight: 600, fontSize: '16px', cursor: 'pointer' }}
            text={translateModals('watchVideo')}
            onClick={handleWatchVideo}
          />
          <p style={{ marginTop: '20px', fontWeight: 300 }}>
            <WebLink
              onClick={closeModal}
              to="#"
              name={translateModals('skipVideo')}
              style={{ textDecoration: 'none', color: '#2878C1' }}
            />
          </p>
        </div>
      ) : (
        <div>
          <Plyr
            key={selectedResource?.title}
            style={{
              width: '80vw'
            }}
            media={{
              type: 'video',
              source: {
                src: selectedResource?.url,
                type: 'video/mp4'
              }
            }}
            title={selectedResource?.title}
            onDone={closeModal}
          />
        </div>
      )}
    </div>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    welcomeModal: {
      width: remCalc(380),
      textAlign: 'center',
      fontFamily: FONT_GSS_FUTURA,
      backgroundColor: '#fff',
      ...ModalPadding,
      '@media(min-width: 1000px)': {
        maxWidth: remCalc(380)
      }
    },
    modalImage: {
      width: '60%',
      minWidth: remCalc(160),
      '@media(min-width: 1000px)': {
        width: '70%',
        minWidth: remCalc(220)
      }
    },
    modalHeading: {
      fontFamily: FONT_GSS_FUTURA,
      fontWeight: '600 !important',
      fontSize: '24px !important',
      '@media(min-width: 1000px)': {
        fontSize: '30px !important'
      },
      padding: '5px'
    },
    modalText: {
      fontFamily: FONT_GSS_FUTURA,
      textAlign: 'left',
      lineHeight: '24px',
      fontWeight: 300
    },
    modalButton: {
      margin: remCalc(20, 0),
      fontFamily: FONT_GSS_FUTURA,
      fontWeight: 300
    }
  }));

export default Welcome;
